import { render, staticRenderFns } from "./hazardFacilitySelfCheckDetail.vue?vue&type=template&id=212a7d3e"
import script from "./hazardFacilitySelfCheckDetail.vue?vue&type=script&lang=js"
export * from "./hazardFacilitySelfCheckDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('212a7d3e')) {
      api.createRecord('212a7d3e', component.options)
    } else {
      api.reload('212a7d3e', component.options)
    }
    module.hot.accept("./hazardFacilitySelfCheckDetail.vue?vue&type=template&id=212a7d3e", function () {
      api.rerender('212a7d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/hcf/hazardFacilitySelfCheckDetail.vue"
export default component.exports